var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { SpeechRecognizer, O } from "vwebapp-framework";
import { runInAction } from "mobx";
import { Timer } from "js-vextensions";
import { voiceCommands, VoiceCommand, SetTextValue } from "./VoiceCommands";
import { UIFocusEngine } from "./UIFocusEngine";
export const unfinishedSegment_ignoreDuration = 200;
export class VoiceEngine {
    constructor() {
        this.enabled = false;
        this.recognizer = new SpeechRecognizer();
        this.uiFocusEngine = new UIFocusEngine(this);
        this.focusCheckTimer = new Timer(100, () => {
            this.UpdateFocusElInfo();
        });
        /*lastTranscript = "";
        Recognizer_OnTranscriptChange = (isRecheck = false)=>{
            const transcript = this.recognizer.GetTranscript(true, true, unfinishedSegment_ignoreDuration);
            let oldCommandsStr: string;
            let newCommandsStr: string;
            for (let oldMatchToPos = transcript.length.KeepAtMost(this.lastTranscript.length); oldMatchToPos >= 0; oldMatchToPos--) {
                const lastTranscript_slicedMatchAttempt = this.lastTranscript.slice(0, oldMatchToPos);
                // only consider splitting old and new command-strings at a white-space character (else can break recognition of an in-progress command-key voicing)
                const charIsWhitespace = oldMatchToPos == transcript.length || transcript.slice(oldMatchToPos, oldMatchToPos + 1).match(/\s/) != null;
                if (charIsWhitespace && transcript.startsWith(lastTranscript_slicedMatchAttempt)) {
                    oldCommandsStr = transcript.slice(0, oldMatchToPos);
                    newCommandsStr = transcript.slice(oldMatchToPos);
                    break;
                }
            }
            this.lastTranscript = transcript;
            if (newCommandsStr == null) return;
    
            console.log(`New commands text: ${newCommandsStr}`, {full: transcript});
            //console.log(`Old commands text: ${oldCommandsStr}`);
    
            const commandMatches = newCommandsStr.Matches(/\d{4}/g);
            const commands = commandMatches.map((match: RegExpMatchArray)=>{
                return voiceCommands.find(a=>`14${a.key.toString().padStart(2, "0")}` == match[0].toString());
            });
            for (const [index, match] of commandMatches.entries()) {
                const command = commands[index];
                if (command == null) continue;
                console.log(`Running command: ${command.name}`);
                command.action({index, match, newCommandsStr, oldCommandsStr, commands});
            }
    
            if (!isRecheck) {
                this.recheckTranscriptAfterDelayTimer.Start();
            }
        };
        recheckTranscriptAfterDelayTimer = new Timer(unfinishedSegment_ignoreDuration, ()=>{
            this.Recognizer_OnTranscriptChange(true);
        }, 1);*/
        this.allProcessedSegments = [];
        this.Recognizer_OnTranscriptChange = (isRecheck = false) => {
            const segments = this.recognizer.GetSegments(true, true, unfinishedSegment_ignoreDuration);
            const newSegments = segments.Except(...this.allProcessedSegments);
            const oldSegments = segments.Except(...newSegments);
            console.log(`New segments text:`, newSegments.map(a => a.text).join(" "), { newSegments, currentSegments: segments });
            //console.log(`Old segments text:`, oldSegments.map(a=>a.text).join(" "));
            // todo: update this to use chain-based matching (for voice-keys other than simple numbers), like in MemoryPromptComponent
            const commands = newSegments.map(segment => {
                const commandKey = segment.text;
                const generalCommandMatch = voiceCommands.find(a => a.voiceKeys.Contains(commandKey));
                if (generalCommandMatch)
                    return generalCommandMatch;
                const uiFocusControlMatch = this.uiFocusEngine.controlInfos.find(a => a.voiceKey == commandKey);
                if (uiFocusControlMatch) {
                    return new VoiceCommand({
                        //index: uiFocusControlMatch.index,
                        name: `Focus element ${uiFocusControlMatch.labelText}`,
                        voiceKeys: [uiFocusControlMatch.voiceKey],
                        action: () => {
                            const el = uiFocusControlMatch.element;
                            if (el.matches("input[type=text], input[type=number], textarea")) {
                                el.focus();
                            }
                            else {
                                el.click();
                            }
                        },
                    });
                }
                return null;
            });
            // part 1: mark command segments as such, so GetUncommitedVoiceTyping() below ignores them
            for (const [index, segment] of newSegments.entries()) {
                const command = commands[index];
                const matchesCommandFormat = segment.text.match(/^1[46]\d\d$/);
                if (command || matchesCommandFormat) {
                    segment["processedAsCommand"] = true;
                }
            }
            // add non-command segments to focused element's text
            if (this.focusElement && this.focusElement.matches("input[type=text], textarea")) {
                const uncommittedVoiceText = this.GetUncommittedVoiceTyping();
                Log("Val:", this.focusElement["value"], "BaseText:", this.focusElement_baseText, "Uncommitted:", uncommittedVoiceText);
                //this.focusElement["value"] = this.focusElement_baseText + uncommittedVoiceText;
                SetTextValue(this.focusElement, this.focusElement_baseText + uncommittedVoiceText);
            }
            // part 2: actually run the commands
            for (const [index, segment] of newSegments.entries()) {
                const command = commands[index];
                if (command == null)
                    continue;
                console.log(`Running command: ${command.name} @segment:`, segment);
                command.action({ index, segment, newSegments, oldSegments, commands });
                //segment["processedAsCommand"] = true;
            }
            if (this.recognizer.GetSegments().All(a => a.isFinal)) {
                this.CommitVoiceTyping();
                Log("Finalizing...");
            }
            this.allProcessedSegments = this.allProcessedSegments.concat(segments).Distinct();
            if (!isRecheck) {
                this.recheckTranscriptAfterDelayTimer.Start();
            }
        };
        this.recheckTranscriptAfterDelayTimer = new Timer(unfinishedSegment_ignoreDuration, () => {
            this.Recognizer_OnTranscriptChange(true);
        }, 1);
        /*this.recognizer.onStartListeners.push(()=>{
            runInAction("VoiceEngine_recognizer_OnStart", ()=>this.enabled = true);
        });
        this.recognizer.onEndListeners.push(()=>{
            runInAction("VoiceEngine_recognizer_OnEnd", ()=>this.enabled = false);
        });*/
        this.recognizer.transcriptChangeListeners.push(this.Recognizer_OnTranscriptChange);
    }
    Start() {
        runInAction("VoiceEngine_Start", () => this.enabled = true);
        this.uiFocusEngine.Start();
        this.focusCheckTimer.Start();
        this.recognizer.StartRecognizing(); // start last
    }
    Stop() {
        runInAction("VoiceEngine_Stop", () => this.enabled = false);
        this.recognizer.StopRecognizing();
        this.uiFocusEngine.Stop();
        this.focusCheckTimer.Stop();
    }
    GetNewFocusElement() {
        let newFocusElement = document.activeElement;
        // if not a text-input or text-area, ignore as focused-element
        if (!newFocusElement?.matches("input[type=text], textarea")) {
            newFocusElement = null;
        }
        return newFocusElement;
    }
    UpdateFocusElInfo(ifSameFocusElResetInfo = false) {
        const newFocusElement = this.GetNewFocusElement();
        if (newFocusElement != this.focusElement || ifSameFocusElResetInfo) {
            this.focusElement = newFocusElement;
            this.focusElement_focusTime = Date.now();
            this.focusElement_baseText = newFocusElement?.value ?? null;
            Log("Updating base-text to:", this.focusElement_baseText);
        }
    }
    /*GetRecognizerSegments() {
        let result = this.recognizer.GetSegments(true, true, unfinishedSegment_ignoreDuration);
        // for now, just ignore any segments starting with 14 or 16; heavy-handed, but not worth the dev-time quite yet
        result = result.filter(a=>!a.text.StartsWithAny("14", "16"));
        return result;
    }*/
    GetUncommittedVoiceTyping() {
        const segments = this.recognizer.GetSegments(true, true, unfinishedSegment_ignoreDuration);
        let segmentsForText = segments.filter(segment => {
            if (segment.initialTime < this.focusElement_focusTime)
                return false;
            if (segment["processedAsCommand"])
                return false;
            // for now, just ignore any segments starting with 14 or 16; heavy-handed, but not worth the dev-time quite yet
            //if (segment.text.StartsWithAny("14", "16")) return false;
            return true;
        });
        // any segment-sequence of [14, XX]/[16, XX], ignore (user was presumably trying to run a command)
        let skipNext = false;
        segmentsForText = segmentsForText.SelectMany((segment, index) => {
            if (skipNext) {
                skipNext = false;
                return [];
            }
            const nextSegment = segmentsForText[index + 1];
            if ((segment.text == "14" || segment.text == "16") && nextSegment?.text.match(/^\d{2}$/)) {
                skipNext = true;
                /*return [
                    new TranscriptSegment(E(segment, {
                        rawText: `${segment.rawText} ${nextSegment.rawText}} [merged]`,
                        text: segment.text + nextSegment.text,
                    })),
                ];*/
                return [];
            }
            return [segment];
        });
        let result = segmentsForText.map(a => a.text).join(" ");
        const charsThatNeedNoSpaceBefore = ",\\.!?;:\\/\\-%\"'";
        const charsThatNeedNoSpaceAfter = "\"'";
        const baseTextEndsWithSpacish = this.focusElement_baseText.match(new RegExp(`(^|[\\s${charsThatNeedNoSpaceAfter}])$`)) != null;
        const resultStartsWithSpacish = result.match(new RegExp(`^[\\s${charsThatNeedNoSpaceBefore}]`)) != null;
        if (result.trim().length && !baseTextEndsWithSpacish && !resultStartsWithSpacish) {
            result = ` ${result}`;
        }
        return result;
    }
    //AddTextToFocusedElement(text: string) {}
    CommitVoiceTyping() {
        //this.focusElement = this.GetNewFocusElement();
        this.UpdateFocusElInfo();
        if (this.focusElement == null)
            return;
        const newText = this.focusElement_baseText + this.GetUncommittedVoiceTyping();
        SetTextValue(this.focusElement, newText);
        this.focusElement_focusTime = Date.now();
        this.focusElement_baseText = newText;
    }
}
__decorate([
    O
], VoiceEngine.prototype, "enabled", void 0);
export const voiceEngine = new VoiceEngine();
